import _sfc_main from "./OptionH5.vue2.mjs";
/* empty css               */
import normalizeComponent from "../../../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("span", _vm._b({ ref: "optionRef", class: ["custom-option", _setup.isActive && "active"], attrs: { "value": _setup.props.value, "disabled": _vm.disabled }, on: { "click": _setup.handleOptionClick } }, "span", _vm.$attrs, false), [_vm._v(" " + _vm._s(_setup.props.label) + " ")]);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "95b1b633"
);
const OptionH5 = __component__.exports;
export {
  OptionH5 as default
};
